export default __webpack_public_path__ + "static/media/pt-BR.456ce7a0.md";